import { render } from "./sponsorsPage.vue?vue&type=template&id=1950bbee&ts=true"
import script from "./sponsorsPage.vue?vue&type=script&lang=ts"
export * from "./sponsorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__